import React from 'react';
import { Box } from '../../base/Box/Box';
import { StatsSectionStoryblok } from '../../types/storyblok';
import renderStoryblokComponents from '../../utils/renderStoryblokComponents';

export const StatsSection = ({
  cards,
  colourScheme = 'white',
  overlayOverBkg,
}: StatsSectionStoryblok) => {
  if (!cards) {
    return null;
  }

  return (
    <Box
      as="section"
      colourScheme={colourScheme || 'white'}
      blockSpacing
      bkg
      overlayOverBkg={overlayOverBkg}
    >
      <Box
        as="div"
        className="mx-auto grid max-w-standard grid-cols-1 gap-7 md:grid-cols-2 md:gap-14 lg:grid-cols-4"
      >
        {renderStoryblokComponents({ blocks: cards })}
      </Box>
    </Box>
  );
};

export default StatsSection;
